<template>
  <base-input
    v-noSpecialCharacters
    v-phone-mask
    type="tel"
    :label="$t('WithdrawToCard | inputPhoneLabel')"
    maxlength="15"
    :error-message="
      !isValid ? `${$t('WithdrawToCard | incorrectPhoneNumber')}` : null
    "
    :model-value="formattedPhoneNumber"
    @update:modelValue="updatePhoneNumber"
  />
</template>

<script>
import BaseInput from '@emcd-shared/base-input'
import noSpecialCharacters from '@/shared/lib/directives/noSpecialCharacters'
import phoneMask from '@/shared/lib/directives/phoneMask'

export default {
  components: { BaseInput },
  props: {
    value: {
      required: true,
    },
  },

  directives: {
    phoneMask,
    noSpecialCharacters,
  },

  emits: ['input'],

  computed: {
    formattedPhoneNumber() {
      return this.value
    },

    // Check that phone number is valid
    isValid() {
      // Empty field is valid
      if (this.value === null || this.value === '') return true

      // Check that the number starts with 7 or 8
      const firstChar = this.value.trim()[0]
      if (firstChar !== '7' && firstChar !== '8') return false

      // Check the length (mask: "7 944 453 76 18")
      if (this.value.length !== 15) return false

      return true
    },
  },

  methods: {
    updatePhoneNumber(value) {
      this.$emit('input', value)
    },
  },
}
</script>
